document.addEventListener("DOMContentLoaded", async () => {
  const countryPopup = document.getElementById("country-popup");
  if (!countryPopup) return;

  if (window.location.pathname.includes("/checkout")) return;

  const closeBtn = countryPopup.querySelector(".country-popup__close");
  const countryLinks = countryPopup.querySelectorAll(".country-popup__item-link");
  const countryInput = countryPopup.querySelector('input[name="country_code"]');
  const countryForm = countryPopup.querySelector("form");
  const switchBtn = countryPopup.querySelector("[data-switch]");
  const stayBtn = countryPopup.querySelector("[data-stay]");
  const detectedNameEl = countryPopup.querySelector("[data-detected-country]");

  const DISMISS_KEY = "isCountryPopupShow";
  if (localStorage.getItem(DISMISS_KEY)) return;

  const EXTERNAL_STORE_BY_COUNTRY = {
    FR: "https://lascal.fr/",
    GB: "https://lascal.uk/",
    US: "https://shoplascal.com/",
  };

  const currentCountry =
    countryPopup.dataset.currentCountry ||
    (window.Shopify && window.Shopify.country) ||
    null;

  const dismiss = () => {
    countryPopup.classList.remove("active");
    localStorage.setItem(DISMISS_KEY, "true");
  };

  closeBtn?.addEventListener("click", dismiss);
  stayBtn?.addEventListener("click", dismiss);

  // Build a set of supported countries from the rendered list (available_countries)
  const availableCountriesSet = new Set(
    Array.from(countryLinks)
      .map((a) => (a.dataset.value || "").toUpperCase().trim())
      .filter(Boolean)
  );

  // Manual selection still works
  countryLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const cc = (e.currentTarget.dataset.value || "").toUpperCase().trim();
      if (!cc) return;

      const externalUrl = EXTERNAL_STORE_BY_COUNTRY[cc];
      if (externalUrl) {
        localStorage.setItem(DISMISS_KEY, "true");
        window.location.href = window.LascalRegionalRouting.buildUrl(externalUrl);
        return;
      }

      if (!countryInput || !countryForm) return;
      countryInput.value = cc;
      localStorage.setItem(DISMISS_KEY, "true");
      window.LascalRegionalRouting.prepareForm(countryForm);
      countryForm.submit();
    });
  });

  try {
    const root = window.Shopify?.routes?.root ? window.Shopify.routes.root : "/";
    const url = `${root}browsing_context_suggestions.json`;

    const res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) return;

    const data = await res.json();
    const detected = data?.detected_values?.country;
    const detectedCountry = (detected?.handle || "").toUpperCase().trim();
    const detectedName = detected?.name;

    if (!detectedCountry || !currentCountry) return;
    if (detectedCountry === currentCountry) return;

    if (detectedNameEl) detectedNameEl.textContent = detectedName || detectedCountry;

    // External store case
    const externalUrl = EXTERNAL_STORE_BY_COUNTRY[detectedCountry];
    if (externalUrl) {
      countryPopup.dataset.suggestedExternalUrl = externalUrl;
      delete countryPopup.dataset.suggestedCountry;

      // Ensure switch button is enabled
      if (switchBtn) {
        switchBtn.disabled = false;
        switchBtn.classList.remove("is-disabled");
      }

    } else {
      // Internal lascal.net market switch only if country exists in available list
      const isSupported = availableCountriesSet.has(detectedCountry);

      if (isSupported) {
        countryPopup.dataset.suggestedCountry = detectedCountry;
        delete countryPopup.dataset.suggestedExternalUrl;

        if (switchBtn) {
          switchBtn.disabled = false;
          switchBtn.classList.remove("is-disabled");
        }
      } else {
        // Not supported: disable switch button (Thailand case)
        delete countryPopup.dataset.suggestedCountry;
        delete countryPopup.dataset.suggestedExternalUrl;

        if (switchBtn) {
          switchBtn.disabled = true;
          switchBtn.classList.add("is-disabled");
          // Optional: change label if you want
          // switchBtn.textContent = "Store not available";
        }
      }
    }

    countryPopup.classList.add("active");

    countryPopup.addEventListener("click", (e) => {
      if (e.target === countryPopup) dismiss();
    });

  } catch (e) {
    return;
  }

  switchBtn?.addEventListener("click", () => {
    // If disabled, do nothing (or dismiss)
    if (switchBtn.disabled) return;

    const externalUrl = countryPopup.dataset.suggestedExternalUrl;
    if (externalUrl) {
      localStorage.setItem(DISMISS_KEY, "true");
      window.location.href = window.LascalRegionalRouting.buildUrl(externalUrl);
      return;
    }

    const cc = countryPopup.dataset.suggestedCountry;
    if (!cc || !countryInput || !countryForm) return;

    countryInput.value = cc;
    localStorage.setItem(DISMISS_KEY, "true");
    window.LascalRegionalRouting.prepareForm(countryForm);
    countryForm.submit();
  });
});